module.exports = __webpack_public_path__ + "static/media/stop.ddb8e757.svg";